import { resourceReducer } from 'redux-resource';
import { reset, httpStatusCodes } from 'redux-resource-plugins';
import metaReducer from './metaReducer';

const simoTopUps = resourceReducer('simoTopUps', {
  plugins: [reset, metaReducer, httpStatusCodes],
});

export default simoTopUps;

export const getAllSimoTopUps = (state, subId) => state.resources[subId];
